import { Metric } from '../utils/metric-formatter';

export const metrics: Metric[] = [
  'Clicks',
  'Impressions',
  'Spend',
  'CTR',
  'TopImpressionRate',
  'AbsoluteTopImpressionRate',
  'ConversionsCredit',
  'PartialConversionRate',
  'PartialConversionCPA',
  'AdvertiserReportedRevenue',
  'RevenueOnAdSpend',
  'AverageCPC',
];
